import React from "react";
import Grid from "@mui/material/Grid2";
import { Box, CardMedia, Typography } from "@mui/material";

const teamColors: { [id: string]: string[] } = {
  TBR: ["#02285C", "#90BDE7", "#FFFFFF"],
  BAL: ["#F25D23", "#000000", "#FFFFFF"],
  NYY: ["#132448", "#FFFFFF", "#FFFFFF"],
  BOS: ["#BD3039", "#0D2B56", "#FFFFFF"],
  TOR: ["#134A8E", "#E8291C", "#FFFFFF"],
  CLE: ["#E31937", "#002B5C", "#FFFFFF"],
  KCR: ["#004687", "#FFFFFF", "#FFFFFF"],
  DET: ["#0C2C56", "#FFFFFF", "#FFFFFF"],
  CHW: ["#000000", "#BFBFBF", "#FFFFFF"],
  MIN: ["#091F40", "#E31E34", "#FFFFFF"],
  HOU: ["#002D62", "#F4911E", "#FFFFFF"],
  SEA: ["#005C5C", "#0C2C56", "#FFFFFF"],
  TEX: ["#C0111F", "#003278", "#FFFFFF"],
  LAA: ["#BA0021", "#003263", "#C4CED4"],
  ATH: ["#00342C", "#FFB400", "#FFFFFF"],
  WSN: ["#AB0003", "#FFFFFF", "#FFFFFF"],
  NYM: ["#F75500", "#002C6E", "#FFFFFF"],
  MIA: ["#019CD6", "#E51829", "#FFFFFF"],
  PHI: ["#C21D39", "#01396F", "#FFFFFF"],
  ATL: ["#D3042B", "#001D3D", "#FFFFFF"],
  CIN: ["#C6011F", "#000000", "#FFFFFF"],
  PIT: ["#F7BF02", "#000000", "#FFFFFF"],
  CHC: ["#123581", "#E62F2E", "#FFFFFF"],
  MIL: ["#18294C", "#FEC430", "#FFFFFF"],
  STL: ["#BE0A15", "#FDDB00", "#FFFFFF"],
  LAD: ["#005A9D", "#FFFFFF", "#FFFFFF"],
  ARI: ["#C71128", "#00C2CE", "#FFFFFF"],
  SDP: ["#2D221C", "#FFC125", "#FFFFFF"],
  SFG: ["#231F20", "#F4793E", "#E8D8C4"],
  COL: ["#503E80", "#BFC2C9", "#FFFFFF"],
  FA: ["#BFBFBF", "#FFFFFF", "#FFFFFF"],
  "0": ["#BFBFBF", "#FFFFFF", "#FFFFFF"],
};

export default function InfoCard({ playerInfoProp, idProp }: { playerInfoProp: any, idProp: string | undefined }) {
  //console.log("PIP", playerInfoProp);
  const getHeadshotUrl = () => {
    return `https://img.mlbstatic.com/mlb-photos/image/upload/d_people:generic:headshot:67:current.png/w_213,q_auto:best/v1/people/${idProp}/headshot/67/current`;
  };

  const getMiLBHeadshotUrl = () => {
    return `https://img.mlbstatic.com/mlb-photos/image/upload/c_fill,g_auto/w_180/v1/people/${idProp}/headshot/milb/current`;
  };

  const bio = playerInfoProp?.common?.playerInfo ?? {};
  const team = playerInfoProp?.common?.teamInfo ?? {};
  const teamCol = (i: number) =>
    team.MLB_AbbName && teamColors[team.MLB_AbbName]
      ? teamColors[team.MLB_AbbName][i]
      : teamColors["FA"][i];

  const prospect = playerInfoProp?.common?.prospect?.[0];
  const draft = playerInfoProp?.draft;
  // The bio/team blobs are stored alongside our own stats, but prospect ranks
  // and draft details only exist on a live FanGraphs page. When that page could
  // not be read we simply do not know them -- say so instead of claiming UDFA.
  const hasLiveExtras = playerInfoProp?.fallback !== true;
  const serviceTime =
    playerInfoProp?.contract?.serviceTime ?? bio.servicetime ?? "0.000";
  const heightDisplay =
    bio.HeightDisplay ||
    (bio.Height ? `${Math.floor(bio.Height / 12)}'${bio.Height % 12}"` : "0.000");

  //console.log(playerInfoProp)

  return (
    <div>
      {playerInfoProp.common !== undefined && (
        <div>
          <div
            style={{
              padding: "20px",
              backgroundColor: teamCol(0),
            }}
          >
            <Grid
              container
              direction="row"
              alignItems="center"
              spacing={2} // Added spacing between grid items
            >


              {/* Player Info Column */}
              <Grid >
                <Typography variant="h4">
                  <span style={{ color: teamCol(1) }}>
                    {bio.firstLastName} ⋅ {bio.Position}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <span style={{ color: teamCol(2) }}>
                    {team.MLB_FullName || "Free Agent"} ({team.llevel ?? ""})
                  </span>
                </Typography>
                <Typography variant="subtitle1">
                  <span style={{ color: teamCol(2) }}>
                    <span style={{ fontWeight: "bold" }}>Age:</span>{" "}
                    {bio.AgeDisplay} ⋅{" "}
                    <span style={{ fontWeight: "bold" }}>DOB:</span>{" "}
                    {bio.BirthDateDisplay}
                  </span>
                </Typography>
                <Typography variant="subtitle1">
                  <span style={{ color: teamCol(2) }}>
                    <span style={{ fontWeight: "bold" }}>Bats/Throws:</span>{" "}
                    {bio.Bats}/{bio.Throws} ⋅{" "}
                    <span style={{ fontWeight: "bold" }}>Service Time:</span>{" "}
                    {serviceTime || "0.000"}
                  </span>
                </Typography>
                <Typography variant="subtitle1">
                  <span style={{ color: teamCol(2) }}>
                    <span style={{ fontWeight: "bold" }}>Height:</span>{" "}
                    {heightDisplay} ⋅{" "}
                    <span style={{ fontWeight: "bold" }}>Weight:</span>{" "}
                    {bio.Weight ? bio.Weight : "0.000"}
                  </span>
                </Typography>
              </Grid>
            </Grid>
          </div>
          <div style={{ padding: "20px" }}>
            {prospect !== undefined && (
              <div>
                <Typography variant="h6">
                  Ranks From Report: <a href="https://www.fangraphs.com/prospects/the-board">{prospect.Type}</a>
                  <br />
                  <span style={{ fontWeight: "bold" }}>Overall Rank: </span>
                  {prospect.Ovr_Rank ? prospect.Ovr_Rank : "NR"}
                  {"  ⋅  "}
                  <span style={{ fontWeight: "bold" }}>Org Rank: </span>
                  {prospect.Org_Rank ? prospect.Org_Rank : "NR"}
                </Typography>
              </div>
            )}
            {hasLiveExtras && draft != null && (
              <div>
                <Typography variant="subtitle1">
                  <span style={{ fontWeight: "bold" }}>Draft: </span>
                  {draft.season} {draft.draftType}
                  , Pick {draft.pickNumber} (Round{" "}
                  {draft.pickRound}, Pick{" "}
                  {draft.roundPickNumber})
                  <br />
                  <span style={{ fontWeight: "bold" }}>Draft Team: </span>
                  {draft.TeamName}
                  <br />
                  <span style={{ fontWeight: "bold" }}>Signing Bonus: </span>
                  {draft.signingBonusFormat}
                  <br />
                  <span style={{ fontWeight: "bold" }}>School: </span>
                  {draft.schoolName}
                  <br />
                </Typography>
              </div>
            )}
            {hasLiveExtras && draft == null && (
              <div>
                <Typography variant="subtitle1">
                  <span style={{ fontWeight: "bold" }}>Draft: UDFA</span>
                  {prospect !== undefined && (
                    <div>
                      <span style={{ fontWeight: "bold" }}>Signing Org: </span>
                      {prospect.Signed_Org} ({prospect.Signed_Yr})
                      <br />
                      <span style={{ fontWeight: "bold" }}>
                        Signing Bonus:{" "}
                      </span>
                      ${prospect.Sign_Bonus}
                      <br />
                      <span style={{ fontWeight: "bold" }}>School: </span>
                      {prospect.School}
                      <br />
                    </div>
                  )}
                </Typography>
              </div>
            )}
            {!hasLiveExtras && (
              <Typography variant="subtitle2" sx={{ color: "rgba(0,0,0,0.6)" }}>
                {bio.College ? `College: ${bio.College}` : "Draft and prospect-rank details are unavailable right now."}
              </Typography>
            )}
          </div>

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              gap: 0, // spacing between images
            }}
          >
            <CardMedia
              component="img"
              image={getHeadshotUrl()}
              alt={bio.firstLastName}
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.src = '/default-headshot.jpg';
              }}
              sx={{
                width: "40%",
                margin: "auto",
                borderRadius: '25%',
                objectFit: 'cover',
                border: `3px solid ${teamCol(1)}`
              }}
            />
            <CardMedia
              component="img"
              image={getMiLBHeadshotUrl()}
              alt={bio.firstLastName}
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.src = '/default-headshot.jpg';
              }}
              sx={{
                width: "40%",
                margin: "auto",
                borderRadius: '25%',
                objectFit: 'cover',
                border: `3px solid ${teamCol(1)}`
              }}
            />
          </Box>
          <Typography variant="subtitle1" style={{ textAlign: "center", }}><a href="https://www.mlb.com/photos/home" style={{ color: "black" }}>@ MLB Photos</a></Typography>
        </div>
      )}
    </div>
  );
}
